import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../api/axiosConfig';
import './OrganizationModals.css';

const EditReportModal = ({ show, report, onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        totalSales: '',
        day: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (show && report) {
            setFormData({
                totalSales: report.totalSales || '',
                day: report.day || ''
            });
        }
    }, [show, report]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const payload = {
                totalSales: parseFloat(formData.totalSales),
                day: parseInt(formData.day)
            };

            const response = await axiosInstance.put(
                `/api/sales-target/reports/${report._id}`,
                payload
            );

            if (response.data.success) {
                onSuccess();
                handleClose();
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update report');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({ totalSales: '', day: '' });
        setError(null);
        onClose();
    };

    const getMonthName = (month) => {
        return new Date(2024, month - 1).toLocaleString('default', { month: 'long' });
    };

    if (!show || !report) return null;

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Edit Sales Report</h2>

                <div className="report-info">
                    <div className="info-row">
                        <span className="label">Salesman:</span>
                        <span className="value">{report.salesmanName}</span>
                    </div>
                    <div className="info-row">
                        <span className="label">Branch:</span>
                        <span className="value">{report.branchName}</span>
                    </div>
                    <div className="info-row">
                        <span className="label">Period:</span>
                        <span className="value">
                            {report.day}/{report.month}/{report.year}
                        </span>
                    </div>
                </div>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Day *</label>
                        <select
                            value={formData.day}
                            onChange={(e) => setFormData({ ...formData, day: parseInt(e.target.value) })}
                            required
                        >
                            {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                                <option key={day} value={day}>{day}</option>
                            ))}
                        </select>
                        <small>Correct the day if needed</small>
                    </div>

                    <div className="form-group">
                        <label>Total Sales *</label>
                        <input
                            type="number"
                            value={formData.totalSales}
                            onChange={(e) => setFormData({ ...formData, totalSales: e.target.value })}
                            placeholder="Enter total sales amount"
                            min="0"
                            step="0.01"
                            required
                        />
                        <small>Update the total sales amount for this report</small>
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={handleClose} className="btn-secondary" disabled={loading}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-primary" disabled={loading}>
                            {loading ? 'Updating...' : 'Update Report'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditReportModal;
